module.exports = __webpack_public_path__ + "img/Sun-Heroes-EDUCATOR-Swag-Graphic.ebb47d22.jpg";